import React from 'react';
import PropTypes from 'prop-types';
import { formatEtDateTime, relativeAge } from './datasetMonitorFormat';

/**
 * TimestampCell
 *
 * Renders a coarse relative age (e.g. "22m ago") with the full Eastern Time
 * instant available as a hover tooltip. Shared by the "New data added",
 * "Current data changed" and per-email "last sent" columns.
 *
 * A missing value renders as blank rather than an em dash: with ~60 rows and
 * three email columns, a grid of dashes read as noise.
 *
 * `notApplicable` still renders "N/A": MonitoredDataset::emitsEmails() is
 * false for the ~15 datasets with no NotificationTypeId (ACRIS, zoning, tax
 * class, Sanborn) - for those, the email columns are not a missing send, they
 * are not a send at all (design spec 6).
 */
const TimestampCell = ({ iso, notApplicable }) => {
	if (notApplicable) {
		return (
			<span className="text-muted" title="This dataset does not send email">
				N/A
			</span>
		);
	}

	if (!iso) {
		return null;
	}

	return <span title={`${formatEtDateTime(iso)} ET`}>{relativeAge(iso)}</span>;
};

TimestampCell.propTypes = {
	iso: PropTypes.string,
	notApplicable: PropTypes.bool,
};

TimestampCell.defaultProps = {
	iso: null,
	notApplicable: false,
};

export default TimestampCell;
